import { CloseOutlined } from "@mui/icons-material";
import { IconButton, ListItem, ListItemAvatar, ListItemIcon, ListItemText, Stack, Typography } from "@mui/material";
import { FileExtensionAvatar } from "Common/Components";
import { formatFileSize } from "Common/Functions";
import type { TYPE_FILE_EXTENSIONS } from "Common/Types";
import { DownloadOutlined } from "Icons/Icons";

interface IAttachmentItem {
  file: File | { name: string; size: number; type: string };
  secondaryText?: string;
  handleRemoveAttachment?: React.MouseEventHandler<HTMLButtonElement>;
  isRejected?: boolean;
  hideCloseButton?: boolean;
  onDownload?: React.MouseEventHandler<HTMLButtonElement>;
}

export const AttachmentItem = (props: IAttachmentItem) => {
  const { file, secondaryText, isRejected, handleRemoveAttachment, hideCloseButton = false, onDownload } = props;

  const getSecondaryAction = () => {
    if (isRejected) return null;

    if (onDownload) {
      return (
        <IconButton size="small" onClick={onDownload}>
          <DownloadOutlined fontSize="small" color="secondary" />
        </IconButton>
      );
    }
    if (!hideCloseButton) {
      return (
        <IconButton size="small" onClick={handleRemoveAttachment}>
          <CloseOutlined fontSize="small" color="secondary" />
        </IconButton>
      );
    }

    return null;
  };

  return (
    <ListItem
      disableGutters
      disablePadding
      key={file.name}
      secondaryAction={getSecondaryAction()}
      sx={(theme) => ({
        border: isRejected ? `1px solid ${theme.palette.grey[300]}` : "none",
        paddingX: 2,
      })}
    >
      <ListItemAvatar>
        <FileExtensionAvatar fileFormat={(file.name.split(".").pop()?.toLowerCase() ?? "") as TYPE_FILE_EXTENSIONS} />
      </ListItemAvatar>
      <ListItemText
        primary={
          <Stack
            direction={"row"}
            spacing={1}
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <Typography noWrap>{file.name}</Typography>
          </Stack>
        }
        secondary={formatFileSize(file.size)}
        slotProps={{ primary: { noWrap: true } }}
        sx={{
          flexGrow: 0,
          width: "80%",

          "& .MuiListItemText-primary": {
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
          },
        }}
      />
      {secondaryText && (
        <ListItemIcon sx={{ mr: 3 }}>
          <Typography color="text.secondary">{secondaryText}</Typography>
        </ListItemIcon>
      )}
    </ListItem>
  );
};
